<template>
   <div>
   <div :class="{ 'desktop': isShowInstall }">
      <div v-if="showFirefox || showIos" id="installApp" class="ios">
         <div class="content mobail">
            <div class="mobail__img">
               <img class="mobail-logo" src="/mobailInstall.svg" />
            </div>
            <div class="text-box mobail-text-box">
               <Typography class="mobail-text">
                  Install Sleep Well Lite <br />
                  to Home Screen?
                  <!-- Install this webapp on your {{ isIOS ? 'Iphone' : 'Phone' }}: <br />
                  tap -->
                  <!-- <img
                     v-if="isIOS"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA+CAYAAACGPyP0AAAKo2lDQ1BJQ0MgUHJvZmlsZQAASImVlgdQFNkWhm93Tw6kIcch55wGkByHIEgGE8PMAEMYxhkGETOyuAJrQEQElAVdBVFwVYKIiohiYFFMmBdkUVHXxYCoqLwGHqNbr/a9eqfq9Pnq9L3nnnu7b9UPAOUmSyBIh2UAyOBnCcP9veixcfF0/GOAATAgAnMgy2KLBJ5hYcEAtbn4d3t/G0DT8Yb5dK3/fP9fTZbDFbEBgMJQTuSI2BkoH0e9gy0QZgGACNC87vIswTSXoiwvRBtEuW6ak2e5Y5oTZ/nazJjIcG+U/wCAQGGxhMkAkMfQPD2bnYzWoaC7BVZ8Do+PsgfKbuwUFgfldSibZWRkTvMhlI0Sv6uT/LeaiZKaLFayhGf3MmMEH55IkM5a8X8ex/+2jHTx3Bq6qFNShAHh0+tNn1taZpCE+YnzQ+eYx5ntaZpTxAFRc8wWecfPMYflEySZmz4/eI6TeH5MSZ0sZuQcCzPDJfW5It+IOWYJv60lTovylKzLZUpq5qZExsxxNi96/hyL0iKCvo3xluSF4nBJz0lCP8keM0Tf7YvHlIzPSokMkOyR9a03rihW0gOH6+MryfOjJGMEWV6S+oL0MMl4brq/JC/KjpDMzUJ/tm9zwyTnk8oKDJtjwAMhgAXYWdycrOmGvTMFK4S85JQsuid6Y7h0Jp9tYUa3sbJmADB9/2Y/77uSmXsFKe35lsu5CoB7NgDwd7k49C4cLgdAIfJbTm8JAHJvADjpwhYLs2dzmOkHFpCANJAHKkAT/X+M0BtuAxyAC/AAviAQhIJIEAeWADZIARlACJaDVWA9KABFYCvYASpANdgL6sBhcBS0gg5wFlwAV8A1cAvcB4NgBLwAY+A9mIQgCA9RIRqkAmlB+pApZAMxIDfIFwqGwqE4KAFKhviQGFoFbYCKoBKoAqqB6qFfoRPQWegS1A/dhYagUegN9AlGYAosD2vABrAlzIA94SA4El4MJ8PL4Fw4H94Ml8O18CG4BT4LX4FvwYPwC3gcAQgZUUS0EXOEgXgjoUg8koQIkTVIIVKG1CKNSDvSg9xABpGXyEcMDkPD0DHmGBdMACYKw8Ysw6zBFGMqMHWYFkw35gZmCDOG+YqlYtWxplhnLBMbi03GLscWYMuw+7HN2PPYW9gR7HscDqeIM8Q54gJwcbhU3EpcMW43rgnXievHDePG8Xi8Ct4U74oPxbPwWfgC/C78IfwZ/HX8CP4DgUzQItgQ/AjxBD4hj1BGOEg4TbhOeEqYJMoQ9YnOxFAih7iCuIW4j9hOvEocIU6SZEmGJFdSJCmVtJ5UTmoknSc9IL0lk8k6ZCfyAjKPvI5cTj5CvkgeIn+kyFFMKN6URRQxZTPlAKWTcpfylkqlGlA9qPHULOpmaj31HPUR9YMUTcpCiinFkVorVSnVInVd6pU0UVpf2lN6iXSudJn0Memr0i9liDIGMt4yLJk1MpUyJ2QGZMZlabLWsqGyGbLFsgdlL8k+k8PLGcj5ynHk8uX2yp2TG6YhNF2aN41N20DbRztPG5HHyRvKM+VT5YvkD8v3yY8pyCnYKUQr5ChUKpxSGFREFA0UmYrpilsUjyreVvykpKHkqcRV2qTUqHRdaUJZTdlDmatcqNykfEv5kwpdxVclTWWbSqvKQ1WMqonqAtXlqntUz6u+VJNXc1FjqxWqHVW7pw6rm6iHq69U36veqz6uoanhryHQ2KVxTuOlpqKmh2aqZqnmac1RLZqWmxZPq1TrjNZzugLdk55OL6d308e01bUDtMXaNdp92pM6hjpROnk6TToPdUm6DN0k3VLdLt0xPS29EL1Veg169/SJ+gz9FP2d+j36EwaGBjEGGw1aDZ4ZKhsyDXMNGwwfGFGN3I2WGdUa3TTGGTOM04x3G18zgU3sTVJMKk2umsKmDqY8092m/WZYMyczvlmt2YA5xdzTPNu8wXzIQtEi2CLPotXilaWeZbzlNssey69W9lbpVvus7lvLWQda51m3W7+xMbFh21Ta3LSl2vrZrrVts31tZ2rHtdtjd8eeZh9iv9G+y/6Lg6OD0KHRYdRRzzHBscpxgCHPCGMUMy46YZ28nNY6dTh9dHZwznI+6vyXi7lLmstBl2fzDOdx5+2bN+yq48pyrXEddKO7Jbj97Dboru3Ocq91f+yh68Hx2O/x1NPYM9XzkOcrLysvoVez14S3s/dq704fxMffp9Cnz1fON8q3wveRn45fsl+D35i/vf9K/84AbEBQwLaAAaYGk82sZ44FOgauDuwOogRFBFUEPQ42CRYGt4fAIYEh20MezNefz5/fGgpCmaHbQx+GGYYtCzu5ALcgbEHlgifh1uGrwnsiaBFLIw5GvI/0itwSeT/KKEoc1RUtHb0ouj56IsYnpiRmMNYydnXslTjVOF5cWzw+Pjp+f/z4Qt+FOxaOLLJfVLDo9mLDxTmLLy1RXZK+5NRS6aWspccSsAkxCQcTPrNCWbWs8URmYlXiGNubvZP9guPBKeWMcl25JdynSa5JJUnPkl2TtyePprinlKW85HnzKnivUwNSq1Mn0kLTDqRNpcekN2UQMhIyTvDl+Gn87kzNzJzMfoGpoEAwuMx52Y5lY8Ig4X4RJFosasuSR4VOr9hI/IN4KNstuzL7w/Lo5cdyZHP4Ob0rTFZsWvE01y/3l5WYleyVXau0V61fNbTac3XNGmhN4pqutbpr89eOrPNfV7eetD5t/W95Vnklee82xGxoz9fIX5c//IP/Dw0FUgXCgoGNLhurf8T8yPuxb5Ptpl2bvhZyCi8XWRWVFX0uZhdf/sn6p/KfpjYnbe7b4rBlz1bcVv7W29vct9WVyJbklgxvD9neUkovLSx9t2PpjktldmXVO0k7xTsHy4PL23bp7dq663NFSsWtSq/Kpir1qk1VE7s5u6/v8djTWK1RXVT96Wfez3dq/Gtaag1qy/bi9mbvfbIvel/PL4xf6ver7i/a/+UA/8BgXXhdd71jff1B9YNbGuAGccPooUWHrh32OdzWaN5Y06TYVHQEHBEfef5rwq+3jwYd7TrGONZ4XP94VTOtubAFalnRMtaa0jrYFtfWfyLwRFe7S3vzSYuTBzq0OypPKZzacpp0Ov/01JncM+Odgs6XZ5PPDnct7bp/Lvbcze4F3X3ng85fvOB34VyPZ8+Zi64XOy45XzpxmXG59YrDlZZe+97m3+x/a+5z6Gu56ni17ZrTtfb+ef2nr7tfP3vD58aFm8ybV27Nv9V/O+r2nYFFA4N3OHee3U2/+/pe9r3J++seYB8UPpR5WPZI/VHt78a/Nw06DJ4a8hnqfRzx+P4we/jFH6I/Po/kP6E+KXuq9bT+mc2zjlG/0WvPFz4feSF4Mfmy4E/ZP6teGb06/pfHX71jsWMjr4Wvp94Uv1V5e+Cd3buu8bDxR+8z3k9OFH5Q+VD3kfGx51PMp6eTyz/jP5d/Mf7S/jXo64OpjKkpAUvImpECCOpwUhIAbw4AQI0DgIbqZtLCWX08Y9Cspp8h8E88q6FnzAGAvZ0ATMu6IDRWoa7vgcp7NIahEZVFsK2txP9toiRbm9la5KWoNFk8NfUWVUA4VON8tZuamjw6NfUF1TXIewDO9M/q8mnDofq9yhD8g/0LST0Do2TTBb4AAAGbaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjUxPC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjYyPC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CjVt7YAAAAdcSURBVGgF7VlNiBxFFH7d07s7sxGjIolmFfUSL4IaMCB6EDYHUTwFDGhQiCKeFPWii+BRvBjxoIcERBCRXDx48RCCIB78YXUNGDFmQ0RDYgQTNDu789Pt+6r7TV7VdNV0ZyZRlzx2571673t/VV091T3RqWPfZ5RlRHGDKO0TRRH/xZQZOSZWEGU9ZgnLjMvSHAvu+BH75TFG+0WcL8/B8Uf4Gaw3H2rj2pmSs21uAEUSF2c4Byet46HRdyEwCVbL0FX1AxbwYjLq+pXWmceM0m6bpSJBnqb4RHFlegt0EVjtr3NoWWO0HMYknc6aRv+v5STiPTIpwjpOLlr9qrBT1w3hFjUg2SHhKzOHa4yWJcYgKAvaLnroQIIvw+SIC/7aR8uCs5oRAIxaFnDoMgL+YuziJzl1DGlUbFKHrk3LVjMC9nHt6Cbw+Wi96y82rffJgg3xie4ZXYgkxeziu1XPstgmzSfajFuwjBtFFhlPugmJN9Fm9MqYwvkDjbT5xBGzEfZL2ZDVDBJJMpF9HLMhtlKZjTPTGR0/E9OLB5q09EuDpqdYmf/BxVBZDNEJBxCykCsLzmoGMyezK7KPI7DYRAY3gfmjyYUfPd2gBW5k/+dT9MJHTfrmeGIa1A25MWSsuY5fJgvWagbAcQmbvckr8jOvyEsfNungrzHt2JLS6b8ieuqDJn17ojHU0Lg5xb9yM7KU4giudUYuGjl6Oqan32tRvxvRgd2rdOZ8RHt3rtEDcylte7dFiyeGV8iNVzaGLkSVmwkFQSPoDCty7PeYnn2/RV1uZO+Tbdp+W5+WzkZ0x40pLTzapl1bMnpkv1qh3DUU3kxaEFAYg82YIgsgrksvMTDh56MjJxu0a3+LuCfat6dNW+f6tNphT7a1O0Sbr8nojcfb9NBcRtveadHXywklqIDxyOXL4eqBLaPgCcAN4hubQtiIh8H5W1LaM9+hrZv61OdG5FCOh0k8sN58bUav7WrT9Z/OUIZnwMhuQ+fQsi7eq19bOedrVPtXkvFdgvoazHss4Fb8x58N2vzKBvpxYYVuv7VH7dWIpngK+5wVD7spc7udSqlKQcGV0R6SEMlLs7MeD95YiS7LsiKDGPBjMvbiS5TZIBbugu51hsmpQ5WbQVy57ZopHZGlwytgkRq2WujWsg4PeGbWsN+YRkHFuXIzaCRh9JeHp+nYydgcT8xsSqSCY+WwqR+8t0Mbr8Z0F1SI2FeffNaks3/jcstfDAlE8xuuy+i+u/iuwQTXKg1ZzUhqOIqMYCCMG42MDi4m9OqhhJ67p08r2ODGmn9EvJl7/ch8++/Yzjo2Wg1jzOrvlmM6ciqmjU3eO7g2C4JtlvfZ2z/FtPumjO6/uzPwh01yubL4W80IGEYtY4wAUOLg+NbDPXr+sfN8t4p5DxgLrBbhe6Z4DZfrEZChMfsvPLFS7KlCWXimaUTJTErzh1r08VeJwfZxR2HS9fhkq5ncLfyJu1AXO5cTg+OFiF1Snri8xTx2n1dPKCvKhCblVUqm87i4G9al2s2UJXALd8euT5m9TOf6jRpbzUhAd6ZHBXHx7tj4S3AewC4k6lIfATEHTvxcWWCxBBMFeJlO2125Lt71946dwHoIWY8RI5FuMdAyxppcR7FpH2D0WDCGewwede6qjEr05uB7y/qhK8341lJfCj7MpdSPfTeTfaL31FBTfGwZ0hVdiV+pXYyMlTxwc+UiFF3SywwFmuPMbxEfW4pyVYFSxKS4tTJ6drSMZL4aBAeuZwzjNIvMM83rO3t0VSs1D2/uEok/cgyRMirRCqH1VjNDwcZQ4LkFR5INsxm9zGcxnNU6vcictscIG3Qd+zLzrZisEi6z1TU+dDLHLLp4jF1dsOKAMdhMnSQuVi8/Vkka0XrU5Y4DtQ5Mbi4xBJupk8iHhd5nkyK83FO1L16wGW8SZfAFVpCB6MP69HVnYexmBpX+B4R11Yx1a5ZLFMsuMibcexkUOI3XfvAFaXuuuRBT8KEc8AFOMK4sMa1mBAyjlgVcxgUHrpO4WMFV1YdwOpaWrWbcAGVjUzSq5n88s5uujTJH85e+vaxQ+3SwIRaIMfKC0RyB4FOTajeDRDNTnIVfO822mF9EUm+NaIyfffFrwqBJL3jYYDWjJqk8FgPwqukw/4C09MO0eW+ML8RJESZqtpnR0nLD/KpgVqgIjtoklStLfqsZAcOoZYwRAB+bNmb05mJEX+xrUlu9wIN5XEJOvHTvcNxn7uwPXgAirq7HK1f9FUBmo4OXezyo+1K7SqOSQ85x+IEXJPpRMayVCYExGwjanMkftPI0IY/xbeYGw2H0SoSiVm4GQRBUXpeGgk7KVnc/Bptxl9eMA9Pk4sdtSlbfTenLE2zGDeKOxy12lL8vn0+/rs5mV5oZdXn8W/Z1tTLWDUDfPUTWs4yNJ3p3E4oeeC1jLH7CRQeuCX4+jNiAd2WJYTWjC9SygMFDemmiDCM64TqmyGITLnpwrfPJE73MdBJdyOWSJ9rM5Sral+cfTYBsSsc0QOIAAAAASUVORK5CYII="
                     alt="tap"
                  /> -->
                  <!-- <img
                     v-else-if="isAndriod"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABHklEQVRoge2XSU7DQBBFH0g4qwxbkuPkABmOAUluCUmkgFiQ6RqEfVhUR97YxiYtu4D/pJIXXXL/UnvQAyF+FS1gDqyAz1BLYAYkDeaqxAB4A8459Qr0G0tXkhbpEFtgBLRDjYF9WHvB+ckssKA7oJux3iUd5rHGXJVZYyFHBT2T0LOsJdEPOWEh2wU9ndDzEXPj25g3wwJ+x03kPYH4g+zCdVjQc1l7j7x3VGbYqezJftl7wDH0PNSYqzIJ9p84Awfsxe6EmpIOsQHuGspYmj7pMFm1Ae4bS1eRBPtPPGNfshPwhD1O7k9CCFEe+YgX5CPekI9ci3wkB/mIN+QjXpGPCPFPkI94QT7iDfnItchHcpCPeEM+4hX5iPgrfAGITasWAq3k4gAAAABJRU5ErkJggg=="
                     alt="tap"
                  /> -->

                  <!-- and then {{ isIOS ? 'Add to homescreen' : 'install' }}. -->
               </Typography>
            </div>
            <SWButton :size="'big'" variant="primary" class="install mobail-install" @click="openInstruction"
               >How To Install</SWButton
            >
            <SWButton :size="'big'" variant="secondary" class="install" @click="closeInstall">Not Now</SWButton>
         </div>
      </div>

      <div
         v-else-if="
            (canBeShowed && showInstallPWAPromptCrutch && (showInstallFromBtn && showInstall && !isIOS && !isFirefox)) ||
            (canBeShowed && showInstallPWAPromptCrutch && (isShowInstallPWA && isShowInstall && !isIOS && !isFirefox))
         "
         id="installApp"
         :class="{ top: isMobile }"
      >
         <div class="content">
            <div class="block__img">
               <img class="logo" src="/android-chrome-192x192.png" />
            </div>
            <Typography :weigth="'medium'" :size="'default'" class="text">
               {{ $t('Main.appInstall') }}
            </Typography>
         </div>

         <!-- НОВЕ -->
         <div class="actions">
            <SWButton
               :size="'small'"
               variant="primary"
               class="install"
               @click="installPWA"
            >
               Install
            </SWButton>
            <SWButton
               :size="'small'"
               variant="secondary"
               class="install install-secondary"
               @click="closeInstall"
            >
               Not Now
            </SWButton>
         </div>
      </div>

      <transition name="fade">
         <AddToHomeScreen v-if="isFirefox && isInstructionOpen" @close="closeHandler" />
         <AddToHomeScreen v-if="isIOS && isInstructionOpen" :ios="true" @close="closeHandler" />
      </transition>
   </div>
		<Notification :show="notificationShowed" :text="notificationText" :color="notificationColor" @closeNotification="closeNotification" />

   </div>
</template>

<script>
import { isMobile, isIOS, isSafari, isFirefox, isAndriod, isChrome } from '../../store/isDevices';
import AddToHomeScreen from './AddToHomeScreen.vue';

import { SWButton } from 'sw-ui-kit';
import Typography from '../UI/Typography.vue';
import Notification from '../UI/Notification.vue';

export default {
   inject: ['cancelPWA'],

   components: { AddToHomeScreen, SWButton, Typography, Notification },

   props: {
      isInstallPWA: {
         type: Boolean,
         default: false,
      },
   },

   data() {
      return {
         e: '',
         isShowInstall: false,
         isInstructionOpen: false,
         showInstall: false, //true
         showInstallFromBtn: true,
         showInstallPWAPromptCrutch: true,
         r: '',
         notificationText: '',
			notificationColor: '',
			notificationShowed: false,

      };
   },
   computed: {
      isShowInstallPWA() {
         return true;
      },
      isMobile() {
         return isMobile;
      },

      isIOS() {
         return isIOS;
      },

      isSafari() {
         return isSafari;
      },

      isAndriod() {
         return isAndriod;
      },

      isFirefox() {
         return isFirefox;
      },

      showFirefox() {
         return (
            this.isAndriod &&
            this.isFirefox &&
            (this.showInstallFromBtn || this.showInstall) &&
            (this.showInstallFromBtn || this.isShowInstallPWA)
         );
      },

      showIos() {
         return (
            this.isIOS &&
            this.isSafari &&
            (this.showInstallFromBtn || this.showInstall) &&
            (this.showInstallFromBtn || this.isShowInstallPWA)
         );
      },
      canBeShowed(){
         return this.$store.getters['app/installPWAcanBeShowed'];
      }
   },

   watch: {
      isInstallPWA() {
         if (isChrome && !isIOS && this.isInstallPWA) {
            this.installPWA();
         } else if (this.isInstallPWA) {
            this.showInstallFromBtn = true;
         } else {
            this.showInstallFromBtn = false;
         }
      },
   },

   mounted() {
      window.addEventListener('beforeinstallprompt', this.saveEventPWA);

      // if we are already in standalone mode, do not show the prompt
      if (this.isStandalonePWA()) {
         this.isShowInstall = false;
         this.showInstall = false;
         this.showInstallFromBtn = false;
         this.showInstallPWAPromptCrutch = false;

         localStorage.setItem('showInstall', 'false');
         localStorage.setItem('doNotShowInstall', 'true');
         localStorage.setItem('showInstallPWAPromptCrutch', 'false');
         return;
      }

      // 2 Read settings from localStorage
      if (localStorage.getItem('showInstall') === 'false') {
         this.showInstall = false;
      }

      if (localStorage.getItem('showInstallPWAPromptCrutch') === 'false') {
         this.showInstallPWAPromptCrutch = false;
      }

      if (localStorage.getItem('doNotShowInstall') === 'true') {
         this.showInstallFromBtn = false;
      }

      // 3 The old check can either be removed or kept as a fallback
      if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
         this.showInstall = false;
         localStorage.showInstall = 'false';
      }
   },

   destroyed() {
      window.removeEventListener('beforeinstallprompt', this.saveEventPWA);
   },

   methods: {
      showNotification(text, color) {
			console.log('show notification')
			this.notificationShowed = true;
			this.notificationText = text;
			this.notificationColor = color;
		},
		closeNotification() {
         this.notificationShowed = false;
   },
      async installPWA() {
         if (this.e) {
            this.e.prompt();
            const { outcome } = await this.e.userChoice;
            if (outcome === 'accepted') {
               this.showInstall = false;
               this.isShowInstall = false;
               this.showInstallFromBtn = false;
               this.showInstallPWAPromptCrutch = false;
               this.e = null;

               localStorage.setItem('showInstall', 'false');
               localStorage.setItem('doNotShowInstall', 'true');
               localStorage.setItem('showInstallPWAPromptCrutch', 'false');
            } else {
               this.isShowInstall = false;
               this.$emit('update:isInstallPWA', false);
            }
         } else {
            this.showNotification('Sleep Well Lite App is already intstalled', 'info');
         }
      },


      saveEventPWA(e) {
         this.e = e;
         if (this.e) {
            this.isShowInstall = true;
            //localStorage.showInstall = true;
         }
      },

      closeInstall() {
         this.$emit('cancel');
         this.isShowInstall = false;
         this.showInstallFromBtn = false;

         this.showInstallPWAPromptCrutch = false;

         localStorage.setItem('doNotShowInstall', 'true');
         localStorage.setItem('showInstallPWAPromptCrutch', 'false');
         sessionStorage.doNotShowInstall = true;
         sessionStorage.setItem('showInstallPWAPromptCrutch', false);
         this.$router.push({ name: 'habits' });
      },

      openInstruction() {
         this.isInstructionOpen = true;
         this.showInstall = false;
      },

      closeHandler() {
         this.showInstall = false;
         this.isInstructionOpen = false;
         this.$emit('update:isInstallPWA', false);
      },
       isStandalonePWA() {
         // iOS Safari PWA
         const isIOSStandalone = window.navigator.standalone === true;
         // Android / Chrome / and others PWA
         const isDisplayModeStandalone =
            window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;

         return isIOSStandalone || isDisplayModeStandalone;
      },
   },
};
</script>

<style scoped>
.ios {
   padding: 5px !important;
   background-color: var(--surface);
}
.ios .logo {
   display: unset !important;
}
.ios .content {
   position: relative;
   bottom: unset;
}
.ios .text {
   font-size: 16px;
   font-weight: 700;
   line-height: 20.8px;
}
.ios .mobail-text {
   font-size: 24px;
   margin-top: 20px;
   margin-bottom: 20px;
}
.ios .text-box img {
   width: 20px;
   vertical-align: middle;
}
.ios .mobail-install {
   margin-bottom: 15px;
}
.ios button {
   font-size: 12px;
}
.ios .mobail__img {
   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
   border-radius: 50px;
   padding: 20px;
}
.ios .mobail {
   flex-direction: column;
   margin-top: 30px;
   margin-bottom: 30px;
}
.block__img {
   margin-right: 30px;
   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
   border-radius: 10px;
}
.block__img .logo {
   margin: 7px;
   text-align: center;
}
.mobail-logo {
   max-width: 180px;
}
#installApp {
   box-shadow: 0px 0px 12px #00000025;
}
#installApp {
   display: flex;
   align-items: center;
   padding: 8px 12px;
   border-radius: 12px;
   background-color: var(--surface);
}

#installApp .content {
   display: flex;
   align-items: center;
   flex: 1 1 auto;
   padding: 8px 0;
}

#installApp .actions {
   display: flex;
   align-items: center;
   gap: 8px;
   flex-shrink: 0;
}

#installApp .install {
   min-height: 37px;
   padding: 0 14px;
}

@media screen and (max-width: 600px) {
   .desktop {
      position: fixed;
      z-index: 100000;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: var(--plashka-install);
      overflow-y: auto;
   }
   #installApp.top {
      flex-wrap: wrap;
      row-gap: 8px;
   }
   #installApp .install{
      justify-content: center;
      align-items: center;
   }
   #installApp.top .actions {
      width: 100%;
      justify-content: center;
      align-items: center;
   }
}
.desktop:not(.desktop:has(#installApp)) {
   display: none;
}
</style>
